import React from 'react';
import { textCaption } from '../../styles/typography';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

export const AuthorName = ({
  children,
  className,
  as: Component = 'div',
  ...props
}: DefaultBsComponent) => {
  return (
    <Component
      {...props}
      className={classNames('AuthorName', textCaption, className)}
    >
      {children}
    </Component>
  );
};
